import script from "./StockChartTraderboard.vue?vue&type=script&setup=true&lang=ts"
export * from "./StockChartTraderboard.vue?vue&type=script&setup=true&lang=ts"

import "./StockChartTraderboard.vue?vue&type=style&index=0&id=53875640&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53875640"]])

export default __exports__